import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import {
  DynamicDialogConfig,
  DynamicDialogRef,
  DialogService,
} from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import {
  dateRangeValidator,
  idadeMinimaValidator,
} from '@validators/date-range.validator';
import { InstituicaoEnsinoCursoService } from '../../api/services';
import { ApiService } from '@core/providers/http';
import { AuthService } from '@core/service/auth.service';
import { DatePicker } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-cadatrar-bolsa',
  imports: [
    ReactiveFormsModule,
    ToastModule,
    DropdownModule,
    InputTextModule,
    ButtonModule,
    Select,
    CalendarModule,
    DatePicker,
    CommonModule,
  ],
  providers: [
    FormBuilder,
    DialogService,
    InstituicaoEnsinoCursoService,
    ApiService,
    MessageService,
  ],
  templateUrl: './cadatrar-bolsa.component.html',
  styleUrls: ['./cadatrar-bolsa.component.scss'],
  standalone: true,
})
export class CadatrarBolsaComponent {
  private authService = inject(AuthService);
  @Input() bolseiros: any[] = [];
  @Input() instituicaoCurso: any[] = [];
  @Input() instituicaoGestora: any[] = [];
  @Input() tipoBolsa: any[] = [];
  @Input() educationalInstitution: any[] = [];
  instituicaoEnsinoCursoService = inject(InstituicaoEnsinoCursoService);
  messageService = inject(MessageService);
  private fb = inject(FormBuilder);
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  instituicaoCursoList: any[] = [];
  generoOptions = [
    { label: 'Masculino', id: 1 },
    { label: 'Feminino', id: 2 },
  ];
  estadoCivilOptions = [
    { label: 'Solteiro', id: 5 },
    { label: 'Casado', id: 1 },
  ];
  institutionForm = this.fb.group(
    {
      numeroDoBI: ['', Validators.required],
      nome: [{ value: '', disabled: true }, Validators.required],
      dataNascimento: [
        { value: '', disabled: true },
        [Validators.required, idadeMinimaValidator(15)],
      ],
      estadoCivil: [{ value: '', disabled: true }, Validators.required],
      genero: [{ value: '', disabled: true }, Validators.required],
      instituicacoCursoID: ['', Validators.required],
      tipoBolsaID: ['', Validators.required],
      instituicaoGestoraID: ['', Validators.required],
      estadoBolsa: ['', Validators.required],
      anoLectivoInicio: ['', Validators.required],
      endereco: [{ value: '', disabled: true }],
      anoLectivoFim: ['', Validators.required],
      idEstadoMatricula: ['', Validators.required],
    },
    {
      validators: dateRangeValidator(
        'anoLectivoInicio',
        'anoLectivoFim',
        'dataInicioFimRange',
      ),
    },
  );

  activeStep: number = 1;

  constructor() {
    // Ensure that data is correctly initialized from config
    if (this.config.data) {
      this.bolseiros = this.config.data.bolseiros || [];
      this.instituicaoCurso = this.config.data.instituicaoCurso || [];
      this.instituicaoGestora = this.config.data.instituicaoGestora || [];
      this.tipoBolsa = this.config.data.tipoBolsa || [];
      this.educationalInstitution =
        this.config.data.educationalInstitution || [];
    }
  }

  searchDocumentNumber() {
    this.authService
      .consultarBi(this.institutionForm.controls['numeroDoBI'].value as any)
      .subscribe((result) => {
        if (result.retorno.codigo === 200) {
          this.institutionForm.patchValue({
            nome: `${result.data.nome} ${result.data.sobrenome}`,
            dataNascimento: new Date(result.data.dataNascimento) as any,
            estadoCivil: +result.data.estadoCivil as any,
            genero: +result.data.genero as any,
            endereco: result.data.morada,
            // Actualize outros campos conforme necessário
          });
        } else {
          console.error(
            'Erro ao buscar informações pelo número do BI:',
            result.retorno.message,
          );
        }
      });
  }

  save() {
    if (this.institutionForm.valid) {
      const formValue = this.institutionForm.value;

      formValue.anoLectivoInicio = formValue.anoLectivoInicio
        ? new Date(formValue.anoLectivoInicio).getFullYear().toString()
        : new Date().getFullYear().toString();

      formValue.anoLectivoFim = formValue.anoLectivoFim
        ? new Date(formValue.anoLectivoFim).getFullYear().toString()
        : new Date().getFullYear().toString();

      this.ref.close(formValue);
    } else {
      this.institutionForm.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail:
          'Por favor, preencha todos os campos obrigatórios corretamente.',
      });
    }
  }

  cancel() {
    this.ref.close();
  }

  onInstitutionChange(event: any) {
    const instituicaoID = event.value;
    this.getAllInstituicaoCurso({
      InstituicaoEnsinoID: instituicaoID,
      pageSize: 100,
    });
  }

  getAllInstituicaoCurso(params: any) {
    this.instituicaoEnsinoCursoService.list(params).subscribe(
      (response) => {
        this.instituicaoCursoList = response.data.map((item: any) => ({
          ...item,
          id: item?.id,
          nome: item?.curso,
        }));
      },
      (error: any) => {
        console.error('Erro ao buscar instituições de curso:', error);
      },
    );
  }
}
